import React, { useState } from "react";
import { Link } from "react-router-dom"; // React Router kullanımı
import { FiLogIn } from "react-icons/fi"; // Login ikonu
import logo from "../assets/softrein.png"; // Logo içerden çekiliyor

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Hamburger menü kontrolü
  const [activeMenu, setActiveMenu] = useState("home"); // Aktif menü kontrolü

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    setIsOpen(false); // Mobilde menü kapanır
  };

  return (
    <nav className="bg-gray-200 shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <Link
            to="/"
            onClick={() => handleMenuClick("home")}
          >
          <img src={logo} alt="Softrein Logo" className="h-10 w-auto mr-2" />
          </Link>
        </div>

        {/* Hamburger Menu */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-gray-700 block sm:hidden focus:outline-none"
        >
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>

        {/* Navbar Links */}
        <div
          className={`${
            isOpen ? "flex flex-col" : "hidden"
          } sm:flex sm:flex-row items-center absolute sm:relative top-16 left-0 sm:top-auto sm:left-auto w-full sm:w-auto bg-gray-200 sm:bg-transparent z-40`}
        >
          {[
            { name: "Anasayfa", id: "home", path: "/" },
            { name: "Hakkımızda", id: "about", path: "/hakkimizda" },
            { name: "Hizmetler", id: "services", path: "/hizmetlerimiz" },
            { name: "Blog", id: "blog", path: "/blog" },
            { name: "İletişim", id: "contact", path: "/iletisim" },
          ].map((menu) => (
            <Link
              key={menu.id}
              to={menu.path}
              onClick={() => handleMenuClick(menu.id)}
              className={`text-gray-700 text-lg px-4 py-2 ${
                activeMenu === menu.id
                  ? "text-blue-500 font-semibold"
                  : "hover:text-blue-500"
              } hover:scale-105 transition-transform`}
            >
              {menu.name}
            </Link>
          ))}
        </div>

        {/* Login Icon */}
        <div className="hidden sm:block">
          <Link to="/login">
            <FiLogIn className="text-gray-700 hover:text-blue-500 text-2xl transition-colors" />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
